export const buttonTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
    roundedBorderRadius: 'var(--pct-50)',
    paddingX: 'var(--rem)',
    paddingY: 'var(--large-padding)',
    iconOnlyWidth: 'var(--trigger-icon-rem)',
    transitionDuration: '0.2s',
    sm: {
      fontSize: 'var(--rem)',
      paddingX: 'var(--half-rem)',
      paddingY: 'var(--half-rem)',
      iconOnlyWidth: 'var(--trigger-icon-rem)',
    },
    lg: {
      fontSize: 'var(--font-size-lg)',
      paddingX: 'var(--half-rem)',
      paddingY: 'var(--half-rem)',
    },
  },
  extend: {
    agility: {
      font: {
        size: 'var(--rem)',
        family: 'var(--lexend-semi-bold)',
      },
      border: {
        width: 'var(--border-width)',
      },
      outlined: {
        primary: {
          hover: {
            color: 'var(--p-white)',
            border: {
              color: 'var(--p-primary-600)',
            },
          },
        },
      },
      text: {
        primary: {
          hover: {
            color: 'var(--p-primary-600)',
          },
        },
        success: {
          hover: {
            color: 'var(--p-success-500)',
          },
        },
      },
      success: {
        text: {
          hover: {
            color: 'var(--p-success-900)',
          },
        },
      },
      trash: {
        color: 'var(--p-primary-500)',
        hover: {
          color: 'var(--p-danger-500)',
        },
      },
    },
  },
  colorScheme: {
    light: {
      primary: {
        color: 'var(--p-white)',
        background: 'var(--p-primary-500)',
        borderColor: 'var(--p-primary-500)',
        hoverBackground: 'var(--p-primary-600)',
        hoverBorderColor: 'var(--p-primary-600)',
        activeBackground: 'var(--p-primary-600)',
        activeBorderColor: 'var(--p-primary-600)',
      },
      success: {
        color: 'var(--p-white)',
        background: 'var(--p-success-500)',
        borderColor: 'var(--p-success-500)',
      },
      warning: {
        color: 'var(--p-white)',
        background: 'var(--p-warning-500)',
        borderColor: 'var(--p-warning-500)',
      },
      danger: {
        color: 'var(--p-white)',
        background: 'var(--p-danger-500)',
        borderColor: 'var(--p-danger-500)',
      },
      help: {
        color: 'var(--p-primary-800)',
        background: 'var(--p-primary-100)',
        borderColor: 'var(--p-primary-100)',
        hoverBackground: 'var(--p-primary-800)',
        hoverColor: 'var(--p-primary-100)',
        hoverBorderColor: 'var(--p-primary-800)',
        activeBackground: 'var(--p-primary-600)',
        activeBorderColor: 'var(--p-primary-600)',
      },
      outlined: {
        primary: {
          color: 'var(--p-primary-500)',
          background: 'var(--transparent)',
          borderColor: 'var(--p-primary-500)',
          hoverBackground: 'var(--p-primary-600)',
          activeBackground: 'var(--p-primary-600)',
        },
        success: {
          color: 'var(--p-success-500)',
          background: 'var(--transparent)',
          borderColor: 'var(--p-success-500)',
          hoverBackground: 'var(--transparent)',
          activeBackground: 'var(--transparent)',
        },
        danger: {
          color: 'var(--p-danger-500)',
          background: 'var(--transparent)',
          borderColor: 'var(--p-danger-500)',
          hoverColor: 'var(--p-white)',
          hoverBackground: 'var(--p-danger-500)',
          activeBackground: 'var(--p-danger-500)',
        },
      },
      text: {
        primary: {
          color: 'var(--p-primary-500)',
          hoverBackground: 'var(--transparent)',
          activeBackground: 'var(--transparent)',
        },
        success: {
          color: 'var(--p-success-500)',
          hoverBackground: 'var(--transparent)',
          activeBackground: 'var(--transparent)',
        },
        info: {
          color: 'var(--p-white)',
        },
        secondary: {
          color: 'var(--text-color-secondary)',
          hoverColor: 'var(--p-primary-500)',
        },
      },
      info: {
        color: 'var(--p-white)',
        background: 'var(--p-primary-500)',
        borderColor: 'var(--p-primary-500)',
      },
      link: {
        color: 'var(--p-primary-500)',
      },
    },
    dark: {
      primary: {
        color: 'var(--white)',
        background: 'var(--p-primary-500)',
        borderColor: 'var(--p-primary-500)',
        hoverBackground: 'var(--p-primary-600)',
        hoverBorderColor: 'var(--p-primary-600)',
        activeBackground: 'var(--p-primary-600)',
        activeBorderColor: 'var(--p-primary-600)',
      },
      success: {
        color: 'var(--p-white)',
        background: 'var(--p-success-500)',
        borderColor: 'var(--p-success-500)',
      },
      warning: {
        color: 'var(--p-white)',
        background: 'var(--p-warning-500)',
        borderColor: 'var(--p-warning-500)',
      },
      danger: {
        color: 'var(--p-white)',
        background: 'var(--p-danger-500)',
        borderColor: 'var(--p-danger-500)',
      },
      help: {
        color: 'var(--p-primary-800)',
        background: 'var(--p-primary-100)',
        borderColor: 'var(--p-primary-100)',
        hoverBackground: 'var(--p-primary-800)',
        hoverColor: 'var(--p-primary-100)',
        hoverBorderColor: 'var(--p-primary-800)',
        activeBackground: 'var(--p-primary-600)',
        activeBorderColor: 'var(--p-primary-600)',
      },
      outlined: {
        primary: {
          color: 'var(--p-primary-500)',
          background: 'var(--transparent)',
          borderColor: 'var(--p-primary-500)',
          hoverBackground: 'var(--p-primary-600)',
          activeBackground: 'var(--p-primary-600)',
        },
        success: {
          color: 'var(--p-success-500)',
          background: 'var(--transparent)',
          borderColor: 'var(--p-success-500)',
          hoverBackground: 'var(--transparent)',
          activeBackground: 'var(--transparent)',
        },
        danger: {
          color: 'var(--p-danger-500)',
          background: 'var(--transparent)',
          borderColor: 'var(--p-danger-500)',
          hoverColor: 'var(--p-white)',
          hoverBackground: 'var(--p-danger-500)',
          activeBackground: 'var(--p-danger-500)',
        },
      },
      text: {
        primary: {
          color: 'var(--p-primary-500)',
          hoverBackground: 'var(--transparent)',
          activeBackground: 'var(--transparent)',
        },
        secondary: {
          color: 'var(--text-color-secondary)',
          hoverColor: 'var(--p-primary-500)',
        },
        success: {
          color: 'var(--p-success-500)',
          hoverBackground: 'var(--transparent)',
          activeBackground: 'var(--transparent)',
        },
        info: {
          color: 'var(--p-white)',
        },
      },
      info: {
        color: 'var(--p-white)',
        background: 'var(--p-primary-500)',
        borderColor: 'var(--p-primary-500)',
      },
      link: {
        color: 'var(--p-primary-500)',
      },
    },
  },
  css: ({ dt }: any) => `
    /* Button overrides */
    .p-button {
      font-family: ${dt('button.agility.font.family')};
    }

    .p-button:not(.p-button-link) {
      border-width: ${dt('button.agility.border.width')} !important;
    }

    .p-button:not(.p-button-sm):not(.p-button-lg) {
      font-size: ${dt('button.agility.font.size')};
    }

    /* Help button overrides */
    .p-button-help {
      border-width: ${dt('button.agility.border.width')};
      box-shadow: var(--none);
    }

    /* Outlined button overrides */
    .p-button-outlined:enabled:hover,
    .p-button-outlined:enabled:active {
      color: ${dt('button.agility.outlined.primary.hover.color')} !important;
    }

    .p-button-outlined:not(.p-button-danger):enabled:hover,
    .p-button-outlined:not(.p-button-danger):enabled:active {
      border-color: ${dt('button.agility.outlined.primary.hover.border.color')} !important;
    }

    /* Text button overrides */
    .p-button.p-button-text, .p-button.p-button-text:hover {
      padding: var(--reset);
    }

    .p-button.p-button-text:not(.p-button-icon-only):enabled:hover,
    .p-button.p-button-text:not(.p-button-icon-only):enabled:active,
    .p-button.p-button-text:not(.p-button-icon-only):enabled:focus {
      text-decoration: underline;
      color: ${dt('button.agility.text.primary.hover.color')};
    }

    /* Trash button overrides */
    .p-button-trash {
      color: ${dt('button.agility.trash.color')};
    }

    .p-button-trash:enabled:hover,
    .p-button-trash:enabled:active,
    .p-button-trash:enabled:focus {
      color: ${dt('button.agility.trash.hover.color')} !important;
    }

    /* Success button overrides */
    .p-button.p-button-success.p-button-text:enabled:hover {
      color: ${dt('button.agility.success.text.hover.color')} !important;
    }
  `,
};
